export default {
  topics: (state) => state.topics,
  topicsInFiveDays: (state) => state.topicsInFiveDays,
  hasNotification: (state) => state.hasNotification,
  topicDetail: (state) => state.topicDetail,
};
